export const apiConfig = {
    baseUrl: process.env.REACT_APP_API_BASE_URI || 'http://localhost:3001'
}
